import { render, staticRenderFns } from "./patrolInfo.vue?vue&type=template&id=56254f35"
import script from "./patrolInfo.vue?vue&type=script&lang=js"
export * from "./patrolInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56254f35')) {
      api.createRecord('56254f35', component.options)
    } else {
      api.reload('56254f35', component.options)
    }
    module.hot.accept("./patrolInfo.vue?vue&type=template&id=56254f35", function () {
      api.rerender('56254f35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/patrolInfo.vue"
export default component.exports